import layerService from '@/api/layerService'

const INTRO_KEY = 'geox_explore_dont_show_intro'

export default {
  name: 'Explore',
  mixins: [],
  components: {
    ExploreSelection: () => import(/* webpackChunkName: "ExploreSelection" */ '@/views/explore/explore-selection/ExploreSelection.vue'),
    ExploreAnalysis: () => import(/* webpackChunkName: "ExploreAnalysis" */ '@/views/explore/explore-analysis/ExploreAnalysis.vue')
  },
  props: {},
  data () {
    return {
      showIntro: true,
      dontShowIntroAgain: false,
      showAnalysis: false,
      analysisModel: undefined,
      zipcodeLayerId: 'explore_zipcodes',
      gridLayerId: 'explore_grids',
      areaLayerId: 'explore_area'
    }
  },
  computed: {},
  mounted () {
    this.showIntro = !localStorage.getItem(INTRO_KEY)
  },
  beforeDestroy () {
    layerService.removeLayer(this.zipcodeLayerId)
    layerService.removeLayer(this.gridLayerId)
    // layerService.removeLayer(this.areaLayerId)
  },
  methods: {
    toggleIntro () {
      this.showIntro = false
      if (this.dontShowIntroAgain) {
        localStorage.setItem(INTRO_KEY, true)
      }
    },
    startAnalysis (model) {
      this.analysisModel = model
    },
    exitAnalysis () {
      this.analysisModel = undefined
    }
  }
}
